import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function StickyFooterCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-[#0d5d55] shadow-[0_-4px_20px_rgba(0,0,0,0.2)] p-3 md:p-4 z-50 animate-slide-up" data-id="element-529">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-4" data-id="element-530">
        {/* Left side - Text (hidden on mobile) */}
        <div className="hidden md:block text-white" data-id="element-531">
          <p className="font-bold text-lg" data-id="element-532">
            LIMITED TIME: 30% OFF + Free Shipping
          </p>
          <p className="text-sm text-[#21afa1]" data-id="element-533">
            Offer expires soon - Don't miss out!
          </p>
        </div>

        {/* CTA Button */}
        <a href="https://trynymera.com/products/nymera-lymphatic-drainage-softgels" className="flex-1 md:flex-none bg-white hover:bg-gray-100 text-[#0d5d55] font-bold py-3 px-6 md:px-8 rounded-lg shadow-md transition-all hover:shadow-lg flex items-center justify-center gap-2 text-base md:text-lg" data-id="element-534">
          <span data-id="element-535">Claim Your Discount</span>
          <ArrowRight className="w-5 h-5" data-id="element-536" />
        </a>
      </div>
    </div>;
}